import { Col } from '@folio/stripes/components';
import React from 'react';
import TimezonePicker from './TimezonePicker';
import DatePartPicker from './DatePartPicker';
export default function CurrentDateToken(_a) {
    var prefix = _a.prefix;
    return (React.createElement(React.Fragment, null,
        React.createElement(Col, { xs: 6 },
            React.createElement(DatePartPicker, { prefix: prefix })),
        React.createElement(Col, { xs: 6 },
            React.createElement(TimezonePicker, { prefix: prefix }))));
}
